export default {
  title: 'Pedidos',
};
